var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { hexToRgb } from './hexToRgb';
export var hexToRgba = function (hex, opacity) {
    if (opacity > 1 || opacity < 0) {
        throw new Error('Opacity must be >= 0 and <= 1');
    }
    return __spreadArrays(hexToRgb(hex), [opacity]);
};
//# sourceMappingURL=hexToRgba.js.map